/**
 * External dependencies
*/
import { useEffect, useState } from '@wordpress/element';
import { registerPaymentMethod } from '@woocommerce/blocks-registry';
import { __ } from '@wordpress/i18n';
import { getSetting } from '@woocommerce/settings';
import { decodeEntities } from '@wordpress/html-entities';

const settings = getSetting('apple-payment_data', {});
const defaultLabel = __('Apple', 'meshulam-payment-gateway');
const label = decodeEntities(settings.title) || defaultLabel;
let currentOrderId = '';

const Content = (props) => {
    const { eventRegistration, emitResponse } = props;
    const { onCheckoutSuccess } = eventRegistration;

    useEffect(() => {

        const unsubscribe = onCheckoutSuccess(async () => {
            try {

                if (!currentOrderId) {
                    console.error("orderId is missing");
                    return;
                }

                const response = await fetch(settings.ajax_url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams({
                        order_id: currentOrderId,
                        action: "meshulam_popup_payment_iframe"
                    })
                });

                const result = await response.text();

                if (!result || result === 'false') {
                    return {
                        type: emitResponse.responseTypes.ERROR,
                        message: 'There was an error',
                    };
                }

                window.location.href = result;

            } catch (error) {
                console.error("Error:", error);
            }

        });

        // Unsubscribes when this component is unmounted.
        return () => {
            unsubscribe();
        };
    }, [
        emitResponse.responseTypes.ERROR,
        emitResponse.responseTypes.SUCCESS,
        onCheckoutSuccess
    ]);

    useEffect(() => {
        const originalFetch = window.fetch;
        window.fetch = async function (...args) {
            const response = await originalFetch(...args);
            const clonedResponse = response.clone();
            if (args[0].includes('/wp-json/wc/store/v1/checkout')) {
                try {
                    const data = await clonedResponse.json();
                    if (data.order_id) {
                        currentOrderId = data.order_id;
                    }
                } catch (error) {
                }
            }
            return response;
        };

        return () => {
            window.fetch = originalFetch;
        };
    }, []);

    return <div>{decodeEntities(settings.description || '')}</div>;
}

const Icon = () => {
    return settings.icon ? <img src={settings.icon} /> : '';
}

const Label = () => {
    return (
        <span className="icon_label">
            <span>{label}</span>
            <Icon />
        </span>
    );
}

const applePaymentMethod = {
    name: settings.name,
    label: <Label />,
    placeOrderButtonLabel: settings.button_title,
    content: <Content />,
    edit: <Content />,
    canMakePayment: () => true,
    ariaLabel: label,
    supports: {
        features: settings.supports ?? [],
    },
}

registerPaymentMethod(applePaymentMethod);